<template>
    <ShoppingCart/>
</template>

<script>
import ShoppingCart from './components/ShoppingCart.vue'

export default {
  name: 'App',
  components: {
    ShoppingCart
  }
}
</script>

<style lang="scss">

@font-face {
    font-family: 'Aktion Mensch Regular';
    src: url('~@/assets/fonts/AktionMenschW05-Regular.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Aktion Mensch Bold';
    src: url('~@/assets/fonts/AktionMenschW05-Bold.woff2') format('woff2');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'icons-webfont';
    src: url('~@/assets/fonts/icons-webfont.woff2') format('woff2'),
         url('~@/assets/fonts/icons-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}

@import './assets/css/reset.css';
@import './../node_modules/animate.css/animate.css';
@import './assets/css/icons-webfont.css';

:root{
  --color-red: #e31519;
  --color-red-hover: #b41114;
  --color-green: #17987d;
  --headline-size: 2.1428571429rem;
  --color-text: #565656;
  --padding-value: 1.8rem;
  --color-button-text: #fff;
  --color-white: #fff;
  --wrapper-padding: 2rem 0.5rem;
  --border-color: #d5d5d5;
  --background-color: #eee;
  --color-form-focus-shadow: #0060cc;
  --spacing: 16px;

  @media (min-width: 900px){
    --spacing: 32px;
  }
}

*{
  font-family: 'Aktion Mensch Regular';
  -webkit-user-select: none;
    user-select: none;

    a{
      color: var(--color-text);
    }
}

#shopping-cart{
  min-height: 398px;
  position: relative;
  background-color: var(--background-color);
}

.shopping-cart-button{
  background-color: var(--color-red);
  color: var(--color-button-text);
  display: inline-block;
  padding: 12px 24px;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border: 2px solid transparent;

  &:hover{
    background-color: var(--color-red-hover);
  }

  &--invert{
    background-color: var(--color-white);
    color: var(--color-red);
    border: 2px solid var(--color-red);
    &:hover{
      background-color: var(--color-red);
      color: var(--color-button-text);
    }
  }
}
.sr-only {
    clip: rect(0,0,0,0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}

</style>
